<template>
    <div style="position: relative;width: 100%;height: 100%;">

        <template v-if="!background_images">
          <template v-if="background_image_url_state">
            <img class="bg_image" :src="background_image_url_state">
          </template>
          <template v-else>
            <img class="bg_image" :src="require('@/assets/static/images/bg/' + background_image)">
          </template>
          <div style="
            background-color: #DEE8F2;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            opacity: 0.5;
          "></div>
        </template>
        <div v-else style="
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        "
        :style="'background-color: ' + background_images"
        ></div>

    <div class="remove__list">
        <span>
            {{ $t('list.messages.pick_a_list') }} 
        </span>
    </div>

    </div>
</template>

<script>

    export default {
        computed: {
            background_image() {
                return this.$store.state.key.background_image
            },
            background_images() {
                let image = this.$store.state.key.background_images.find(e => e.image_name == this.$store.state.key.background_image)
                if (image) {
                    return image.color ? image.color : false
                } else {
                    return false
                }
            },
            background_image_url_state() {
                return this.$store.state.key.background_image_url
            }
        }
    }

</script>